export enum UserBusinessType {
    EmployeeUser = 0,
    TechnicalProductionUser = 1,
    TechnicalToolManagementUser = 2
}
